import React, {Component} from 'react';
import {connect} from 'react-redux';
import {setActivePuzzle} from '../state/activePuzzle';
import {hideAlert} from '../state/showAlert';
import {purePuzzles} from '../purePuzzles';
import {LanguageContext} from "../App";
import ListItem from "./ListItem";

class ListOfPuzzles extends Component {
    render() {
        let allPuzzles = <LanguageContext.Consumer>{({language}) => {

            const chars = {"ę": "e", "ó": "o", "ł": "l", "ś": "s", "ą": "a", "ż": "z", "ź": "z", "ć": "c", "ń": "n"};
            const puzzles = Object.keys(purePuzzles).map(id => purePuzzles[id]);
            let searchedTags = this.props.searchValue.split(' ').map(tag => tag.toLowerCase().replace(/[^\w ]/g, function (c) {
                return chars[c] || c;
            })).filter(tag => tag.trim() !== '');
            let searchedPuzzles = searchedTags.length ? puzzles.filter(puzzle => {
                let joinedPuzzleTags = (language[puzzle.tags] || []).join(' ');
                let matchedTags = [];
                searchedTags.forEach(tag => {
                    return joinedPuzzleTags.indexOf(tag) > -1 ? matchedTags.push(tag) : '';
                });
                if (matchedTags.length) {
                    return puzzle;
                }
                return null;
            }) : puzzles;
            let allCommands = [...new Set(searchedPuzzles.map(puzzle => puzzle.category))];


            let isOpened = puzzles.length !== searchedPuzzles.length;

            return <ul className={'left-menu-list'}>
                {allCommands.map((category, i) => <ListItem key={i}
                                                            allCommands={allCommands}
                                                            iterator={i}
                                                            matchedPuzzles={puzzles.filter(puzzle => puzzle.category === category)}
                                                            category={category}
                                                            language={language}
                                                            setActivePuzzle={this.props.setActivePuzzle}
                                                            isOpened={isOpened}
                    />
                )}
            </ul>
        }}
        </LanguageContext.Consumer>;


        return (
            <div>
                {allPuzzles}
            </div>
        )
    }
}

export default connect(
    state => ({
        purePuzzles: state.purePuzzles,
        alert: state.showAlert,
    }),
    {setActivePuzzle, hideAlert}
)(ListOfPuzzles);



// WEBPACK FOOTER //
// ./src/LeftMenu/ListOfPuzzles.js